import { useEffect, useState } from "react";

const Rangefilter = ({ setFilters, filter }) => {
    const [min, setMin] = useState(filter.value?.min ?? '');
    const [max, setMax] = useState(filter.value?.max ?? '');
    
    // Listen to external filter changes (like reset)
    useEffect(() => {
        setMin(filter.value?.min ?? '');
        setMax(filter.value?.max ?? '');
    }, [filter.value?.min, filter.value?.max]);
    
    const setFilterValue = () => {
        setFilters((filters) => {
            const newFilters = [...filters];
            newFilters[filters.findIndex((e) => e.index == filter.index)].value = { 
                min: min === '' ? undefined : min, 
                max: max === '' ? undefined : max 
            }
            return newFilters
        })
    }
    
    useEffect(() => {
        setFilterValue();
    }, [min, max])
    
    const setMinValue = (value) => {
        setMin(value);
    }
    
    const setMaxValue = (value) => {
        setMax(value);
    }
    
    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 p-4 border border-gray w-100">
            <h6 className="fw-bold">{filter.name}</h6>
            <div className="d-flex flex-row align-items-center rangeInputs">
                <input 
                    type="number" 
                    min={filter.min || null} 
                    value={min}
                    onChange={(e) => setMinValue(e.target.value)} 
                    placeholder="0,00" 
                    className="standardInput w-100 placeholderStyle" 
                    step="0.01"
                />
                <span className="px-2"> - </span>
                <input 
                    type="number" 
                    max={filter.max || null} 
                    value={max}
                    onChange={(e) => setMaxValue(e.target.value)} 
                    placeholder="0,00" 
                    className="standardInput w-100 placeholderStyle" 
                    step="0.01"
                />
            </div>
        </div>
    </div>
}

export default Rangefilter;